import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    buttons: {
      approve: 'Approve',
      reject: 'Refuse',
    },
    errors: {
      notEnoughFunds:
        'There are insufficient funds to cover the fees including all taxes.',
    },
    fees: {
      all: 'You will be charged **€{orderFee} excl. VAT for the shipment** then **€{monthlyFee}/month excl. VAT** when the card is activated.',
      free: 'This card is included in your subscription. That means it is **free**!',
      onlyMonthly:
        'You will be charged **€{monthlyFee}/month excl. VAT** when the card is activated.',
      onlyOrder:
        'You will be charged **€{orderFee} excl. VAT** for the shipment.',
      title: 'Card cost',
    },
  },
  fr: {
    buttons: {
      approve: 'Approuver',
      reject: 'Refuser',
    },
    errors: {
      notEnoughFunds:
        'Les fonds sont insuffisants pour couvrir les frais, toutes taxes comprises.',
    },
    fees: {
      all: 'Vous serez facturé·e de **{orderFee}\xa0€ HT pour l’envoi** puis **{monthlyFee}\xa0€ / mois HT** à l’activation de la carte.',
      free: 'Cette carte est incluse dans votre abonnement. Elle est donc **gratuite**\xa0!',
      onlyMonthly:
        'Vous serez facturé·e de **{monthlyFee}\xa0€ / mois HT** à l’activation de la carte.',
      onlyOrder: 'Vous serez facturé·e de **{orderFee}\xa0€ HT pour l’envoi**.',
      title: 'Prix de la carte',
    },
  },
} as const);

export default locales;
